
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FloatingCTA from '../components/FloatingCTA';
import ProcessTimeline from '../components/ProcessTimeline';
import Button from '../components/Button';
import { Check, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Leistungen = () => {
  const processSteps = [
    {
      number: 1,
      title: "Erstberatung und Bedarfsanalyse",
      description: "Wir besprechen Ihre Wünsche und Anforderungen, um Ihr Projekt genau zu verstehen."
    },
    {
      number: 2,
      title: "Planung und Konzepterstellung",
      description: "Wir entwickeln ein individuelles Konzept, das Ihre Vorstellungen und Budget berücksichtigt."
    },
    {
      number: 3,
      title: "Detailplanung und Materialauswahl",
      description: "Gemeinsam legen wir alle Details fest und wählen hochwertige Materialien für Ihr Projekt."
    },
    {
      number: 4,
      title: "Professionelle Bauausführung",
      description: "Unser erfahrenes Team führt alle Arbeiten präzise und termingerecht durch."
    },
    {
      number: 5,
      title: "Qualitätskontrolle",
      description: "Wir kontrollieren regelmäßig die Qualität der ausgeführten Arbeiten gemäß höchster Standards."
    },
    {
      number: 6,
      title: "Termingerechte Übergabe",
      description: "Wir übergeben Ihr Projekt pünktlich und in höchster Qualität an Sie."
    }
  ];

  const services = [
    {
      title: "Schlüsselfertig Massivbau",
      description: "Wir realisieren Ihren Massivbau von der ersten Planung bis zur schlüsselfertigen Übergabe. Unser erfahrenes Team kümmert sich um alle Aspekte des Bauprozesses, damit Sie sich um nichts kümmern müssen.",
      benefits: [
        "Komplettservice aus einer Hand",
        "Hochwertige, langlebige Materialien",
        "Termintreue und transparente Kostenkalkulation",
        "Energieeffiziente Bauweise nach neuesten Standards"
      ],
      image: "https://smfuwrmdonlmchctxvjq.supabase.co/storage/v1/object/public/leistungen//leistungen-1.png"
    },
    {
      title: "Hybridhäuser - Beton und Holz",
      description: "Unsere Hybridhäuser vereinen die Vorteile von Beton und Holz in einem innovativen Konzept. Die Betonelemente sorgen für Stabilität und Sicherheit, während die Holzelemente natürliches Wohngefühl und hervorragende Energieeffizienz bieten.",
      benefits: [
        "Optimale Verbindung traditioneller und moderner Baustoffe",
        "Höhere Energieeffizienz durch natürliche Wärmedämmung",
        "Gesundes Raumklima durch atmungsaktive Materialien",
        "Ästhetische Gestaltungsmöglichkeiten"
      ],
      image: "https://smfuwrmdonlmchctxvjq.supabase.co/storage/v1/object/public/leistungen//leistungen-2.png"
    },
    {
      title: "Holzhäuser",
      description: "Nachhaltige Holzhäuser sind unsere Spezialität. Wir setzen auf nachwachsende Rohstoffe und eine moderne Holzbauweise, die höchsten Ansprüchen an Wohnqualität und Energieeffizienz gerecht wird.",
      benefits: [
        "Natürliche, nachhaltige Bauweise",
        "Hervorragende Wärmedämmung und Energieeffizienz",
        "Schnellere Bauzeit durch vorgefertigte Elemente",
        "Gesundes, behagliches Wohnklima"
      ],
      image: "https://smfuwrmdonlmchctxvjq.supabase.co/storage/v1/object/public/leistungen//leistungen-3.png"
    },
    {
      title: "Schlüsselfertige Sanierung",
      description: "Von der energetischen Sanierung bis zur kompletten Modernisierung - wir bringen Ihr Bestandsobjekt auf den neuesten Stand der Technik und des Wohnkomforts.",
      benefits: [
        "Umfassende Bestandsanalyse und Konzepterstellung",
        "Energieeffiziente Modernisierung",
        "Werterhaltung und Wertsteigerung Ihrer Immobilie",
        "Koordination aller Gewerke aus einer Hand"
      ],
      image: "https://smfuwrmdonlmchctxvjq.supabase.co/storage/v1/object/public/leistungen//leistungen-4.png"
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="section-padding bg-primary-brand text-white pt-32 relative overflow-hidden">
        <div className="container-custom text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold mb-8">Unsere Leistungen</h1>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed opacity-90">
            AMMING GmbH bietet Ihnen ein umfassendes Leistungsspektrum im Baubereich. Von der Planung bis zur Ausführung setzen wir auf Qualität, Innovation und Nachhaltigkeit.
          </p>
        </div>
      </section>

      {/* Service Detail Sections */}
      {services.map((service, index) => (
        <section key={index} className="section-padding bg-white">
          <div className="container-custom">
            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-16 items-center ${
              index % 2 === 1 ? 'lg:grid-flow-dense' : ''
            }`}>
              <div className={`space-y-8 fade-in-up ${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                <h2 className="text-4xl font-bold text-primary-brand">{service.title}</h2>
                <p className="text-lg text-gray-600 leading-relaxed">
                  {service.description}
                </p>
                <div>
                  <h3 className="text-xl font-semibold text-primary-brand mb-6">Ihre Vorteile:</h3>
                  <ul className="space-y-4">
                    {service.benefits.map((benefit, benefitIndex) => (
                      <li key={benefitIndex} className="flex items-start space-x-4">
                        <div className="w-6 h-6 rounded-full bg-primary-brand flex items-center justify-center mt-1 flex-shrink-0">
                          <Check className="h-3 w-3 text-white" />
                        </div>
                        <span className="text-gray-600 leading-relaxed">{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className={`fade-in-up-delay ${index % 2 === 1 ? 'lg:col-start-1' : ''}`}>
                <div className="group relative overflow-hidden rounded-2xl shadow-elegant hover:shadow-elegant-lg transition-all duration-300">
                  <img 
                    src={service.image}
                    alt={service.title}
                    className="w-full h-[400px] lg:h-[500px] xl:h-[550px] object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent opacity-60"></div>
                  <div className="absolute inset-0 rounded-2xl shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* Process Section */}
      <section className="section-padding bg-primary-brand text-white relative overflow-hidden">
        <div className="container-custom relative z-10">
          <div className="text-center mb-16 fade-in-up">
            <h2 className="text-4xl font-bold mb-6">Unser Prozess</h2>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed">
              Von der ersten Idee bis zur Übergabe begleiten wir Sie professionell durch alle Projektphasen.
            </p>
          </div>

          <ProcessTimeline steps={processSteps} />
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="section-padding bg-white">
        <div className="container-custom text-center">
          <div className="max-w-3xl mx-auto space-y-8 fade-in-up">
            <h2 className="text-4xl font-bold text-primary-brand">
              Bereit für Ihr Bauprojekt?
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              Lassen Sie uns gemeinsam Ihre Bauträume verwirklichen. Kontaktieren Sie uns für ein unverbindliches Beratungsgespräch.
            </p>
            <div className="pt-8">
              <Link to="/kontakt">
                <Button variant="primary" size="lg" icon={<ArrowRight className="w-5 h-5" />}>
                  Jetzt Kontakt aufnehmen
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingCTA />
    </div>
  );
};

export default Leistungen;
